import React, { useRef, useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { ArrowClockwise } from 'react-bootstrap-icons';

export const UpdateService = ({updateDataFunction, gridRef,  active, show = true, mode="lg", isJobRunning = true}) => {
    const initialTime = 10;
    const [time, setTime] = useState(initialTime);
    const [isSmall, setIsSmall] = useState(window.innerWidth < 768 );
    useEffect(() => { 
      if(time >= 0)
      {
        if(active && isJobRunning)
        {
          const timerId = setInterval(() => {
            setTime(time - 1);
          }, 1000);
          return () => clearInterval(timerId);
        }
      }
      else
      {
        if(isJobRunning)
        {
          updateDataFunction();
          setTime(initialTime);
        }
        
      }
    }, [time, updateDataFunction, active, isJobRunning]);

    useEffect(() => {
      const handleResize = () => {
        setIsSmall(window.innerWidth < (768));
      };

      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleRefresh = async () => {
      updateDataFunction();
      setTime(initialTime);
    };

    const formatTime = (totalSeconds) => {
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };
    
    return show && <Row xs={12} sm={12} md={12} lg={12}>
      <Col lg={{offset:8, span:4}} md={{offset:7, span:5}} className="small-text text-end d-flex justify-content-end" style={{"textAlign": "end"}} >
        <Button name="refresh" className="jobAction button-table outside-table-button" onClick={handleRefresh} label="refresh">
          <div className={`d-none d-${mode}-inline-block`}>Time Until Refresh: {formatTime(time)}</div>
          <ArrowClockwise/>        
        </Button>
      </Col>
    </Row>
};

